import unescape from 'lodash.unescape';

const formatTreatmentData = (treatments = []) =>
  treatments.reduce((accum, exp) => {
    const factors = exp.factors?.reduce((accum, { key, value }) => {
      accum[key] = value;
      return accum;
    }, {});

    accum[exp.experimentName] = {
      ...exp,
      factors: factors || null,
    };
    return accum;
  }, {});

const formatUrlOverrideTreatmentData = overrides => {
  if (!overrides) {
    return;
  }

  return Object.entries(overrides).reduce(
    (accum, [key, val]) => ({
      ...accum,
      [key]: { experimentName: key, treatmentName: val },
    }),
    {},
  );
};

// First we verify that globals.initialGqlData.checkoutSession.cart
// has information, also we verify if it is a string, if it is a string
// it means that the information was escaped, so here we unescaped it,
// parse it in a json again and reload it in initialGqlData
const unescapeInitialGqlData = globals => {
  try {
    if (typeof globals?.initialGqlData?.checkoutSession?.cart === 'string') {
      const { cart } = globals.initialGqlData.checkoutSession;
      const unescapeData = JSON.parse(unescape(cart));
      globals.initialGqlData.checkoutSession.cart = unescapeData;
    }
    // This code is added because we had an XSS also in the merchant
    // see https://engineering.paypalcorp.com/jira/browse/SVM-3425
    // @TODO: We need to find a generic solution for XSS attacks,
    // otherwise they will continue to appear in different places.
    if (
      typeof globals?.initialGqlData?.checkoutSession?.merchant === 'string'
    ) {
      const { merchant } = globals.initialGqlData.checkoutSession;
      const unescapeData = JSON.parse(unescape(merchant));
      globals.initialGqlData.checkoutSession.merchant = unescapeData;
    }

    // DTOPPOR-1166 XSS issue via UL page
    if (typeof globals?.initialGqlData?.unifiedLoginContext === 'string') {
      const { unifiedLoginContext } = globals.initialGqlData;
      const unescapeData = JSON.parse(unescape(unifiedLoginContext));
      globals.initialGqlData.unifiedLoginContext = unescapeData;
    }
  } catch (error) {
    if (globals.uri?.loggerEndpoint) {
      const { browserName, browserVersion, channel } = globals.device || {};
      const payload = {
        events: [
          {
            event: 'weasley_init_data_unescape_error',
            level: 'warn',
            payload: {
              browserName,
              browserVersion,
              channel,
              token: globals.user.ecToken,
            },
          },
        ],
        meta: {
          state: 'ui_init',
          token: globals.user.ecToken,
        },
      };
      fetch(globals.uri.loggerEndpoint, {
        body: JSON.stringify(payload),
        headers: {
          'content-type': 'application/json',
          'x-app-name': 'checkoutuinodeweb_weasley',
        },
        method: 'POST',
      }).catch(() => null);
    }
  }
};

export {
  formatTreatmentData,
  formatUrlOverrideTreatmentData,
  unescapeInitialGqlData,
};
